import React from 'react';
import SomethingWentWrong from "../../../layout/default/something-went-wrong/SomethingWentWrong";
import * as Sentry from '@sentry/react';

interface ErrorBoundaryState {
    hasError: boolean;
    errorMessage?: string;
}

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return {hasError: true, errorMessage: error.message};
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        Sentry.captureException(error);
        console.error('Error caught by Error Boundary: ', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <SomethingWentWrong/>
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
